/* Report Container */
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, DropdownButton, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReportController from './ReportController';

import '../../styles/report.scss';

class Report extends Component {
  componentDidMount() {
    ReportController.init({
      hasArchive: this.props.hasArchive,
      reportName: this.props.name,
      user: this.props.user,
    });
  }

  componentWillUnmount() {
    ReportController.destroy();
  }

  // see styles/report.scss as well
  render() {
    return (
      <div id="report-module">
        <div>
          <div style={{ float: 'left', margin: '0 15px' }}>
            <div id="showOptionsButtonDiv" style={{ float: 'left' }}>
              <Button
                id="showOptionsButton"
                variant="success"
                size="sm"
                onClick={ReportController.showOptions}
                style={{ marginRight: '5px' }}
              >
                Options / Re-Run
              </Button>
            </div>
            <div style={{ display: 'none' }} id="actionButtonsDiv">
              <Button
                id="graphsButton"
                variant="primary"
                size="sm"
                onClick={ReportController.toggleGraphs}
                style={{ display: 'none' }}
              >
                Graphs
              </Button>
              <DropdownButton variant="primary" size="sm" title="Export" id="exportDropdownButton" renderMenuOnMount>
                <Dropdown.Item eventKey="1" onClick={ReportController.exportCSV}>
                  Comma Separated (.csv)
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={() => ReportController.exportXLS()}>
                  Excel Workbook (.xlsx)
                </Dropdown.Item>
                <Dropdown.Item eventKey="4" onClick={() => ReportController.exportPDF()}>
                  Download PDF
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="5" onClick={ReportController.shareLink}>
                  Share URL
                </Dropdown.Item>
                {this.props.hasArchive && <Dropdown.Divider />}
                {this.props.hasArchive && (
                  <Dropdown.Item eventKey="6" onClick={() => ReportController.archive('csv')}>
                    Send Comma Separated (.csv) to archive
                  </Dropdown.Item>
                )}
              </DropdownButton>
              <DropdownButton variant="primary" size="sm" title="Layout" id="layoutDropdownButton" renderMenuOnMount>
                <Dropdown.Item eventKey="1" onClick={ReportController.autoSizeColumns}>
                  Autosize Columns
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={ReportController.fitAllColumns}>
                  Fit All Columns
                </Dropdown.Item>
                <Dropdown.Item eventKey="3" onClick={ReportController.toggleVerticalHeaders}>
                  Toggle Vertical Headers
                </Dropdown.Item>
                <Dropdown.Item eventKey="4" onClick={ReportController.resetGrid}>
                  Reset
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Header id="layoutMenuHeader" />
                <Dropdown.Item eventKey="6" onClick={ReportController.loadLayoutDialog}>
                  Load Layout
                </Dropdown.Item>
                <Dropdown.Item eventKey="7" onClick={ReportController.saveLayout}>
                  Save Layout
                </Dropdown.Item>
                <Dropdown.Item eventKey="8" onClick={ReportController.deleteLayout} id="deleteLayoutButton">
                  Delete Layout
                </Dropdown.Item>
              </DropdownButton>
              <Button id="clearFiltersButton" variant="primary" size="sm" onClick={ReportController.clearAllFilters}>
                Clear Filters
              </Button>
              <span
                id="refreshNotificationSpan"
                className="text-warning"
                style={{ display: 'none', marginLeft: '35px' }}
              >
                Refreshing Data ...
              </span>
            </div>
          </div>
          <div id="quickFilterDiv">
            <div className="form-group" style={{ position: 'relative', marginBottom: '0px' }}>
              <input
                id="quickFilterInput"
                className="form-control"
                onChange={_.throttle(ReportController.quickFilter, 150)}
                placeholder="Quick Filter"
                style={{ marginBottom: '2px' }}
                type="text"
              />
              <span id="searchClearButton">
                <i
                  className="zmdi zmdi-close-circle-o"
                  onClick={ReportController.clearQuickFilter}
                  style={{ cursor: 'pointer' }}
                />
              </span>
              <span id="rowCountSpan" />
            </div>
          </div>
          &nbsp;
        </div>

        <div id="optionsSetDiv" style={{ clear: 'left', margin: '13px 0 0 15px' }} />

        <div id="noDataDiv" style={{ marginTop: '40px' }}>
          No results.
        </div>

        <div id="waitingDiv" style={{ marginTop: '40px' }}>
          <div id="waitingloader">
            <div id="blockG_1" className="waitingBlock" />
            <div id="blockG_2" className="waitingBlock" />
            <div id="blockG_3" className="waitingBlock" />
          </div>
          Waiting For Results: <span id="waitingSecs">0s</span>
          <br />
          <span id="waitingBranch" style={{ fontSize: '0.75em' }} />
        </div>

        <div id="graphsContainer" className="graphsContainer" style={{ clear: 'both', display: 'none' }} />

        <div id="gridDiv" className="ag-theme-balham" style={{ clear: 'both', margin: '10px' }} />

        <div id="optionsModalDiv" className="modal">
          <div className="modal-dialog responsiveModal">
            <div className="modal-content">
              <div className="modal-header">
                <div className="row" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                  <div style={{ float: 'right' }}>
                    <i
                      className="zmdi zmdi-close"
                      onClick={ReportController.optionsCancel}
                      style={{ cursor: 'pointer', marginTop: '2px' }}
                    />
                  </div>
                  <div>
                    <strong>Report Options</strong>
                  </div>
                </div>
              </div>
              <div className="modal-body" id="optionsForm">
                {/* dynamic option controls rendered here */}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-success"
                  type="button"
                  id="saveOptionsButton"
                  onClick={ReportController.optionsSaveAndRun}
                >
                  Save & Run
                </button>
                <button
                  className="btn btn-secondary"
                  type="button"
                  id="cancelOptionsButton"
                  onClick={ReportController.optionsCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div id="shareModalDiv" className="modal">
          <div className="modal-dialog responsiveModal">
            <div className="modal-content">
              <div className="modal-header">
                <div className="row" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                  <div style={{ float: 'right' }}>
                    <i
                      className="zmdi zmdi-close"
                      onClick={ReportController.shareCancel}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <div>
                    <strong>Share Report Link</strong>
                  </div>
                </div>
              </div>
              <div className="modal-body" id="shareForm">
                <input type="text" id="shareLinkInput" style={{ width: '100%' }} readOnly />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-success"
                  type="button"
                  id="shareClipboardButton"
                  data-clipboard-target="#shareLinkInput"
                >
                  Copy to Clipboard
                </button>
                <button className="btn btn-secondary" type="button" onClick={ReportController.shareCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* used for mapbox onhover statistics */}
        <span className="tooltiptext" id="tooltiptext">
          Tooltip text
        </span>
      </div>
    );
  }
}

// Make sure this component receives the report name to run
Report.propTypes = {
  hasArchive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    hasArchive: state.app.config.hasArchive,
    user: state.app.user,
  };
}
export default connect(mapStateToProps)(Report);
